export const HIGHTOUCH_API_HOST = 'us-east-1.hightouch-events.com/v1'
